import classNames from "classnames";
import { html } from "lit-html";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";

export interface Props {
	checked: boolean;
	label: string;
	justify?: "start" | "end";
	onClick: () => void;
}

export const name = "admin-checkbox";

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		checked: host.checked || false,
		justify: host.justify,
		label: host.label || "",
		onClick: host.onClick || (() => {}),
	};

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		props.onClick();
	};

	return html`
		<label
			class=${classNames("flex select-none cursor-pointer items-center gap-2 whitespace-nowrap", {
				"justify-end": props.justify !== "start",
			})}
			@click=${handleClick}
		>
			<input type="checkbox" class="pointer-events-none" ?checked=${props.checked} />
			<span>${props.label}</span>
		</label>
	`;
};
